import React, { useState } from 'react';
import { textFilter } from 'react-bootstrap-table2-filter';
import { BsFolderPlus } from 'react-icons/bs';
import { VscRefresh, VscSearch } from 'react-icons/vsc';
import { useDispatch, useSelector } from 'react-redux';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../../services/actions';
import Bouton from '../../UI/Bouton/Bouton';
import Tableau from '../../UI/tableau/Tableau';
import styles from './TableauProjet.module.scss';

const TableauProjet = ({ creer, projetSelectione }) => {
  const dispatch = useDispatch();
  const listeProjets = useSelector((state) => state.authentifie.projects_list);

  const [iconeCreer] = useState(<BsFolderPlus size={15} />);
  const [columns, setColumns] = useState([
    {
      dataField: 'project_id',
      text: [
        checkMot('id'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('project_id', checkMot('id'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'project_name',
      text: [
        checkMot('nom'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('project_name', checkMot('nom'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'groupe',
      text: [
        checkMot('groupe'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('groupe', checkMot('groupe'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'description',
      text: [
        checkMot('description_de_projet'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('description', checkMot('description_de_projet'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'parent_id',
      text: [
        checkMot('id_du_projet_parent'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('parent_id', checkMot('id_du_projet_parent'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'project_image',
      text: [
        checkMot('image_de_projet'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() =>
            afficherFiltre('project_image', checkMot('image_de_projet'))
          }
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'active',
      text: [
        checkMot('etat'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('active', checkMot('etat'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'geo_barr',
      text: [
        checkMot('geo_barriere'),
        <Bouton
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('geo_barr', checkMot('geo_barriere'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      formatter: (cell) => {
        if (cell === '[]' || cell === '' || cell === null) {
          return checkMot('non_existant');
        }
        return checkMot('existant');
      },
    },
  ]);

  const [selectRow] = useState({
    mode: 'radio',
    clickToSelect: true,
    hideSelectAll: true,
    hideSelectColumn: true,
    style: () => ({
      background: '#eeb214',
      color: 'black',
    }),
    onSelect: (row) => projetSelectione(row),
  });

  const afficherFiltre = (dataField, placeholder) => {
    setColumns((prevColumns) =>
      prevColumns.map((col) =>
        col.dataField === dataField
          ? { ...col, filter: textFilter({ placeholder }) }
          : col
      )
    );
  };

  const handleRefresh = () => {
    dispatch(actions.reqRecupererListeProjets());
  };

  return (
    <>
      <Tableau
        privilegeCreer={privilege.creer_des_projets}
        creer={creer}
        iconeCreer={iconeCreer}
        cleLigne={'project_id'}
        donnees={listeProjets}
        colonnes={columns}
        selectionnerLignes={selectRow}
      >
        <AttenteRequete
          request_type={requestType.recuperation_de_la_liste_des_projets}
          str={checkMot('maj_projets_en_cour')}
        >
          <Bouton
            hoverText={checkMot('refresh')}
            ajoutClass={styles.btn}
            type={type_btn.outil}
            rond={true}
            cliquer={handleRefresh}
          >
            <VscRefresh size={15} />
          </Bouton>
        </AttenteRequete>
      </Tableau>
    </>
  );
};

export default TableauProjet;
